"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eachTimeSlotOfInterval = void 0;
const date_fns_1 = require("date-fns");
const start_of_time_slot_1 = require("../start-of-time-slot/start-of-time-slot");
/**
 * @summary Returns the array of time slots within the specified interval.
 *
 * Returns the start dates for all time slots within the specified interval. Time slots are 15 minutes long and
 * 15 minute aligned.
 *
 * @param {Interval} interval
 * @returns {Date[]}
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 */
function eachTimeSlotOfInterval(interval) {
    const startDate = (0, date_fns_1.toDate)(interval.start);
    const endDate = (0, date_fns_1.toDate)(interval.end);
    if (!(0, date_fns_1.isValid)(startDate) || !(0, date_fns_1.isValid)(endDate) || startDate.getTime() > endDate.getTime()) {
        throw new RangeError('Invalid interval');
    }
    const timeSlots = [];
    let currentTimeSlot = (0, start_of_time_slot_1.startOfTimeSlot)(startDate);
    const endTime = endDate.getTime();
    while (currentTimeSlot.getTime() <= endTime) {
        timeSlots.push(currentTimeSlot);
        currentTimeSlot = (0, date_fns_1.add)(currentTimeSlot, { minutes: 15 });
    }
    return timeSlots;
}
exports.eachTimeSlotOfInterval = eachTimeSlotOfInterval;
